import { useSelector } from "react-redux";

// TODO: This logic can be re-written once we integrate with final server data,
// as a few further validations might be required here.
export default function useGetAllTourneyTickets() {
  return useSelector((state) => {
    const tickets = state?.lobby?.tourneyTickets;
    return tickets || [];
  });
}







